import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import uniqueId from 'react-html-id';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';

import FilterMenu from './FilterMenu';
import Check from './Check';
import LaunchByHand from './LaunchByHand';

import Loading from '../../dialogs/loading';
import Error from '../../dialogs/Error';
import Snackbar from '../../labels/Snackbar';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';
import * as actionsprocess from '../../../actions/api.process.actions';

import { FilterIcon, AddIcon, RefreshIcon } from '../../../images/icons/WrapSvg';

function toolbar(handleFilter, secondary, handleRefresh) {
    const aux = [];
    aux.push(
        <RefreshIcon key={'refresh-menu-toolbar'} color={'primary'} onClick={handleRefresh} />,
        <FilterIcon
            key={'filter-menu-toolbar'}
            color={!secondary ? 'primary' : 'secondary'}
            onClick={handleFilter}
        />,
    );
    return aux;
}

class Families extends React.Component {
    constructor(props) {
        super(props);
        uniqueId.enableUniqueIds(this);

        this.state = {
            refreshing: false,
            open: undefined,
            dialog: false,
            family: undefined,
        };

        const { from, to, ended, local, lastWeek } = props.process_paramters;
        props.loadProcesses(lastWeek, from, to, ended, local);

        this.interval = setInterval(() => {
            const { dialog } = this.state;
            if (!dialog) {
                this.setState({ refreshing: true });
                const { lastWeek, from, to, ended, local } = this.props.process_paramters;
                this.props
                    .loadProcesses(lastWeek, from, to, ended, local)
                    .then(() => this.setState({ refreshing: false }));
            }
        }, 60000);
    }

    updateTitle = (props) => {
        const { param, process } = props;
        if (process !== undefined && param !== undefined && props.param !== this.state.family) {
            const family = process.find((family) => family.id === param);
            this.props.setProminentToolBar(true);
            if (family !== undefined) {
                this.props.setCurrentWindow(family.nombre);
            } else {
                this.props.setCurrentWindow(param);
            }
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.updateTitle(nextProps);
        this.setState({ family: nextProps.param });
    }

    componentDidMount() {
        const { from, to, ended, local, lastWeek } = this.props.process_paramters;
        const tools = [
            toolbar(
                this.handleFilter,
                from || to || ended || local || !lastWeek,
                this.handleRefresh,
            ),
        ];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
        clearInterval(this.interval);
    }

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (lastWeek, from, to, ended, local) => {
        this.props.setParamters(lastWeek, from, to, ended, local);
        this.props.loadProcesses(lastWeek, from, to, ended, local);
        const tools = [
            toolbar(
                this.handleFilter,
                from || to || ended || local || !lastWeek,
                this.handleRefresh,
            ),
        ];
        this.props.setTools(tools);
        this.setState({
            open: undefined,
            lastWeek: lastWeek,
            from: from,
            to: to,
            ended: ended,
            local: local,
            refreshing: false,
            error: undefined,
        });
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClick = () => {
        this.setState({ dialog: true });
    };

    handleCloseDialog = (refresh) => {
        this.setState({ dialog: false });
    };

    handleRefresh = () => {
        this.setState({ refreshing: false });
        const { lastWeek, from, to, ended, local } = this.props.process_paramters;
        this.props.loadProcesses(lastWeek, from, to, ended, local);
    };

    handleError = (error) => {
        this.setState({ error: error, dialog: false });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    handleCloseMessage = () => {
        this.props.cleanMessages();
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    render() {
        const { refreshing, open, dialog, error } = this.state;
        const {
            info,
            param,
            process,
            process_messages,
            process_is_loading,
            process_has_error,
            process_paramters,
        } = this.props;
        const { lastWeek, from, to, ended, local } = process_paramters;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '57') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (process_has_error.hasErrored && !refreshing) {
            return <Error open message={process_has_error.error} handleClose={this.handleBack} />;
        } else {
            let data = process;
            if (process !== undefined && param !== undefined) {
                const family = process.find((family) => family.id === param);
                if (family !== undefined) {
                    data = family.procesos;
                }
            }

            return (
                <div className={'flex_full_column padding_bottom_9 height100'}>
                    {process_is_loading && !refreshing && <Loading open opacity />}
                    <div
                        className="flex_full showbar overflow_y_scroll"
                        onScroll={this.handleScroll}
                    >
                        <Grid container>
                            {data &&
                                data.length > 0 &&
                                data
                                    .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                    .map((info, i) => {
                                        return (
                                            <Check
                                                key={this.nextUniqueId()}
                                                data={info}
                                                last={data.length === i + 1}
                                                primary={param === undefined}
                                            />
                                        );
                                    })}
                        </Grid>
                        {!param && (
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float_50'}
                                onClick={(e) => this.handleClick(e)}
                            >
                                <AddIcon />
                            </Fab>
                        )}
                    </div>
                    {open && (
                        <FilterMenu
                            anchorEl={open}
                            from={from}
                            to={to}
                            ended={ended}
                            local={local}
                            lastWeek={lastWeek}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                    {dialog && (
                        <LaunchByHand
                            onClose={this.handleCloseDialog.bind(this)}
                            onError={this.handleError.bind(this)}
                            family={param}
                        />
                    )}
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleCloseError.bind(this)}
                        />
                    )}
                    {process_messages && process_messages.length > 0 && (
                        <Snackbar
                            open={true}
                            variant="warning"
                            text={process_messages.join(', ')}
                            onClose={this.handleCloseMessage.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

Families.propTypes = {
    info: PropTypes.object.isRequired,
    process: PropTypes.array.isRequired,
    process_messages: PropTypes.array.isRequired,
    process_is_loading: PropTypes.bool.isRequired,
    process_has_error: PropTypes.object.isRequired,
    process_paramters: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        process: state.process,
        process_messages: state.process_messages,
        process_is_loading: state.process_is_loading,
        process_has_error: state.process_has_error,
        process_paramters: state.process_paramters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsprocess), dispatch);
};

Families = withRouter(Families);

Families = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Families);

export default Families;



// WEBPACK FOOTER //
// ./src/components/complex/families/Families.js